module.exports = __webpack_public_path__ + "img/1528493980.55f2ac94.jpg";